// extracted by mini-css-extract-plugin
export var button = "_f6-4";
export var hasDarkBackground = "_f6-7";
export var hasLightBackground = "_f6-6";
export var iconWrapper = "_f6-0";
export var large = "_f6-2";
export var medium = "_f6-1";
export var small = "_f6-5";
export var xsmall = "_f6-3";